__turbopack_context__.v({
  "authors": "publication-search-card-module-scss-module__QvGSIW__authors",
  "badgeWrapper": "publication-search-card-module-scss-module__QvGSIW__badgeWrapper",
  "badges": "publication-search-card-module-scss-module__QvGSIW__badges",
  "body": "publication-search-card-module-scss-module__QvGSIW__body",
  "card": "publication-search-card-module-scss-module__QvGSIW__card",
  "cardWrapper": "publication-search-card-module-scss-module__QvGSIW__cardWrapper",
  "date": "publication-search-card-module-scss-module__QvGSIW__date",
  "description": "publication-search-card-module-scss-module__QvGSIW__description",
  "heading": "publication-search-card-module-scss-module__QvGSIW__heading",
  "image": "publication-search-card-module-scss-module__QvGSIW__image",
  "imageWrapper": "publication-search-card-module-scss-module__QvGSIW__imageWrapper",
  "mainText": "publication-search-card-module-scss-module__QvGSIW__mainText",
});
